import { type KyInstance } from 'ky';

import {
  IReqCreate,
  IResCreateOrderError,
  IResCreateOrderOk,
  IResCreateOrderUnauthorized,
} from '@/types/parcel/createOrder/create.interface';
import {
  IReqP99,
  IResP99Error,
  IResP99OK,
  IResP99Unauthorized,
} from '@/types/parcel/createOrder/p99.interface';
import {
  IReqQuotation,
  IResQuotationError,
  IResQuotationOK,
  IResQuotationUnauthorized,
} from '@/types/parcel/createOrder/quotation.interface';

type CreateReq = (
  ars: IReqCreate,
) => Promise<IResCreateOrderOk | IResCreateOrderError | IResCreateOrderUnauthorized>;

type QuotationReq = (
  args: IReqQuotation,
) => Promise<IResQuotationOK | IResQuotationError | IResQuotationUnauthorized>;

type P99Req = (ars: IReqP99) => Promise<IResP99OK | IResP99Error | IResP99Unauthorized>;
export interface IReqCreateOrder {
  quotation: QuotationReq;
  create: CreateReq;
  p99: P99Req;
}
export function reqCreateOrder(http: KyInstance): IReqCreateOrder {
  const route = 'api/order';

  return {
    quotation: async (args) => {
      const response = await http.post(`${route}/quotation`, { json: args });
      return response.json();
    },
    create: async (args) => {
      const response = await http.post(`${route}/create`, { json: args });
      return response.json();
    },
    p99: async (args) => {
      const response = await http.post(`api/locations/nearest-points`, { json: args });
      return response.json();
    },
  };
}
